import { createFileRoute } from "@tanstack/react-router";
import { PakistanMatrixPage } from "@/components/pakistan/PakistanMatrixPage";
import { goldRatesQueryOptions } from "@/lib/nonblocking-rates";
import { SITE_URL, DEFAULT_OG_IMAGE, hreflangLinks } from "@/lib/seo";

const PATH = "/pakistan/per-ratti";

export const Route = createFileRoute("/pakistan/per-ratti")({
  loader: ({ context }) => context.queryClient.prefetchQuery(goldRatesQueryOptions),
  head: () => {
    const title = `Gold Rate Per Ratti in Pakistan Today — 24K, 22K, 21K`;
    const description = `Aaj Pakistan mein 1 ratti sone ka rate — chhoti jewellery aur stone settings ke liye. Har karat, har city. Refreshed every 10 minutes.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: `${SITE_URL}${PATH}` },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_PK" },
        { property: "og:image", content: DEFAULT_OG_IMAGE },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: `${SITE_URL}${PATH}` }, ...hreflangLinks(PATH)],
    };
  },
  component: () => (
    <PakistanMatrixPage
      mode={{ kind: "unit", unit: "per-ratti" }}
      h1="Gold Rate Per Ratti in Pakistan Today — Live"
      intro="Aaj Pakistan mein 1 ratti (0.121 gram) sone ka rate — chhoti jewellery items, nose pins, aur stone settings ke liye common weight. Har karat, har sarafa bazaar ka live rate."
    />
  ),
});